import {createSlice} from "@reduxjs/toolkit";


const initialState = {
    page: 1,
}


const paginationSlice = createSlice({
    name: "paginationSlice",
    initialState,
    reducers: {
        changePage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: builder =>
        builder
});

const {reducer: paginationReducer, actions} = paginationSlice;
const paginationActions = {
    ...actions
}

export {
    paginationReducer,
    paginationActions
}